
  import { Component, Vue, Prop } from 'vue-property-decorator';
  import moment from 'moment';

  import { IErrorModel } from '@/models/errors.model';

  @Component
  export default class InputDate extends Vue {
    @Prop()
    public Label!: string;

    @Prop()
    public Name!: string;

    @Prop()
    public Value!: string;

    @Prop()
    public MinimumAge!: number;

    @Prop({ default: false, type: Boolean })
    public CheckMinimumAge!: boolean;

    @Prop({ default: false, type: Boolean })
    public IsReadOnly!: boolean;

    @Prop({ default: false, type: Boolean })
    public IsOptional!: boolean;

    @Prop({ default: false, type: Boolean })
    public FocusInput!: boolean;

    @Prop({ default: '', type: String })
    public Condition!: string;

    @Prop({ default: null, type: String })
    public Placeholder!: string;

    @Prop()
    public Errors!: Array<IErrorModel>;

    public data() {
      return {
        isFocused: false,
        isLabeled: false,
        hasErrors: false,
        inputValue: '',
        errors: new Array <IErrorModel> ()
      }
    };

    public created(): void {
      this.$data.errors = this.Errors;
      this.$watch(() => this.Errors, (params) => {
        this.$data.errors = this.Errors;
        this.$data.hasErrors = this.Errors.length > 0;
      });
      this.$watch(() => this.$data.inputValue, (params) => {
        this.$data.isLabeled = this.$data.inputValue != null && this.$data.inputValue != "";
      });
    }

    public beforeMount(): void {
      this.$data.inputValue = this.Value;
      this.$data.errors = this.Errors;
      this.$data.isLabeled = this.$data.inputValue != null && this.$data.inputValue != "";
    }

    public focusInput(): void {
      this.$data.isFocused = true;
    }

    public blurInput(): void {
      if (!this.hasBadDateInput()) {
        setTimeout(() => {
          this.$data.isFocused = false;
          this.$data.isLabeled = this.$data.inputValue != null && this.$data.inputValue != "";
        }, 300);
      }
    }

    public changeInput(): void {
      setTimeout(() => {      
        this.$emit('update:input:value', this.Name, this.$data.inputValue);

        if (this.CheckMinimumAge && this.MinimumAge && moment(this.$data.inputValue).add(this.MinimumAge, 'year').isAfter(moment())) {
          this.$emit('update:input:errors', [{ Property: "DateOfBirth", ErrorMessage:  `ERROR_DATEOFBIRTH_BELOW_THRESHOLD_AGE` } as IErrorModel]);
        }
        else {
          this.$emit('update:input:errors', []);
        }
      }, 200);
    }

    public showCalendar(): void {
      (this.$refs.inputdate as HTMLInputElement).showPicker();
    }

    public hasBadDateInput(): boolean {
      return (this.$refs.inputdate as HTMLInputElement).validity.badInput;
    }
  }
